import { render, staticRenderFns } from "./ShareDialog.vue?vue&type=template&id=9d37243c&scoped=true&"
import script from "./ShareDialog.vue?vue&type=script&lang=ts&"
export * from "./ShareDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShareDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShareDialog.vue?vue&type=style&index=1&id=9d37243c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d37243c",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,QInput,QField,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,QInput,QField})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
